// (function () {
//   var BODY_STICKY_CLASS = 'is-custom-header-sticky';
//   var headerEl = null;
//   var stickStartY = 0;
//   var scrollRaf = 0;

//   function findCustomHeader() {
//     var inner = document.querySelector('.custom-header');
//     return inner ? inner.closest('header') : null;
//   }

//   function readStickStartY() {
//     if (!headerEl) return 0;
//     var had = document.body.classList.contains(BODY_STICKY_CLASS);
//     document.body.classList.remove(BODY_STICKY_CLASS);
//     void headerEl.offsetHeight;
//     var y = Math.round(headerEl.getBoundingClientRect().top + window.scrollY);
//     if (had) document.body.classList.add(BODY_STICKY_CLASS);
//     return y;
//   }

//   function refreshStickStart() {
//     headerEl = findCustomHeader();
//     if (!headerEl) return;
//     stickStartY = readStickStartY();
//     syncStickyClass();
//   }

//   function syncStickyClass() {
//     if (!headerEl) return;
//     document.body.classList.toggle(BODY_STICKY_CLASS, window.scrollY >= stickStartY);
//   }

//   function onScroll() {
//     if (!headerEl) return;
//     if (scrollRaf) return;
//     scrollRaf = window.requestAnimationFrame(function () {
//       scrollRaf = 0;
//       syncStickyClass();
//     });
//   }

//   function initHeaderSticky() {
//     refreshStickStart();
//     if (!headerEl) return;

//     window.addEventListener('scroll', onScroll, { passive: true });
//     window.addEventListener('resize', refreshStickStart);
//     window.addEventListener('orientationchange', refreshStickStart);

//     if (typeof Shopify !== 'undefined' && Shopify.designMode) {
//       document.addEventListener('shopify:section:load', function () {
//         refreshStickStart();
//         mountMegaNavGrids();
//         initMobileDrawer();
//       });
//       document.addEventListener('shopify:section:unload', refreshStickStart);
//       document.addEventListener('shopify:section:reorder', refreshStickStart);
//     }

//     syncStickyClass();
//   }

//   function setActivePanel(menu, handle) {
//     var panels = menu.querySelectorAll('[data-product-panel]');
//     var matched = false;
//     panels.forEach(function (panel) {
//       var isMatch = handle && panel.getAttribute('data-product-panel') === handle;
//       panel.classList.toggle('is-active', isMatch);
//       if (isMatch) matched = true;
//     });
//     if (!matched && panels.length) {
//       var fallback = menu.getAttribute('data-default-panel');
//       panels.forEach(function (panel) {
//         panel.classList.toggle('is-active', !!(fallback && panel.getAttribute('data-product-panel') === fallback));
//       });
//     }
//   }

//   function stripBoldTags(str) {
//     return String(str || '')
//       .replace(/<\s*b\s*>/gi, '')
//       .replace(/<\s*\/\s*b\s*>/gi, '')
//       .trim();
//   }

//   function mountMegaNavGrids() {
//     document.querySelectorAll('[data-mega-nav-uid]').forEach(function (el) {
//       var uid = el.getAttribute('data-mega-nav-uid');
//       if (!uid) return;
//       var scriptEl = document.getElementById('mega-nav-data-' + uid);
//       if (!scriptEl || !scriptEl.textContent) return;
//       var groups;
//       try {
//         groups = JSON.parse(scriptEl.textContent.trim());
//       } catch (err) {
//         return;
//       }
//       if (!Array.isArray(groups) || !groups.length) return;

//       el.innerHTML = '';
//       var grid = document.createElement('div');
//       grid.className = 'custom-header__mega-nav-grid';
//       el.appendChild(grid);

//       groups.forEach(function (g) {
//         var col = document.createElement('div');
//         col.className = 'custom-header__mega-nav-column';

//         var headingWrap = document.createElement('p');
//         headingWrap.className = 'custom-header__mega-nav-column__heading';
//         var headA = document.createElement('a');
//         headA.href = g.url && String(g.url).trim() ? g.url : '#';
//         headA.className = 'custom-header__mega-nav-column__heading-link';
//         headA.textContent = stripBoldTags(g.headline);
//         headingWrap.appendChild(headA);
//         col.appendChild(headingWrap);

//         var ul = document.createElement('ul');
//         ul.className = 'custom-header__mega-nav-column__list';
//         (g.children || []).forEach(function (ch) {
//           var li = document.createElement('li');
//           li.className = 'custom-header__mega-nav-column__item';
//           var a = document.createElement('a');
//           a.href = ch.url && String(ch.url).trim() ? ch.url : '#';
//           a.className = 'custom-header__menu-list-link--child custom-header__menu-list-link--child-2';
//           a.textContent = stripBoldTags(ch.title);
//           li.appendChild(a);
//           ul.appendChild(li);
//         });
//         col.appendChild(ul);
//         grid.appendChild(col);
//       });
//     });
//   }

//   function initMegaMenu() {
//     document.querySelectorAll('[data-mega-menu]').forEach(function (menu) {
//       var triggers = menu.querySelectorAll('[data-product-panel-trigger]');

//       menu.addEventListener('mouseenter', function () {
//         var def = menu.getAttribute('data-default-panel');
//         if (def) setActivePanel(menu, def);
//       });

//       triggers.forEach(function (li) {
//         li.addEventListener('mouseenter', function () {
//           var handle = li.getAttribute('data-product-panel-trigger');
//           if (handle) setActivePanel(menu, handle);
//         });
//       });

//       menu.addEventListener('mouseleave', function () {
//         var def = menu.getAttribute('data-default-panel');
//         if (def) setActivePanel(menu, def);
//       });
//     });
//   }

//   var MOBILE_DRAWER_BODY_CLASS = 'header__drawwer-open';

//   function syncMobileDrawerOpen(isOpen) {
//     var drawerRoot = document.querySelector('[data-mobile-drawer]');
//     var openBtn = document.querySelector('.custom-header__hambergur-btn');
//     document.body.classList.toggle(MOBILE_DRAWER_BODY_CLASS, isOpen);
//     if (drawerRoot) {
//       drawerRoot.classList.toggle('is-open', isOpen);
//       drawerRoot.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
//     }
//     if (openBtn) openBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
//   }

//   function bindMobileDrawerGlobalsOnce() {
//     if (bindMobileDrawerGlobalsOnce.did) return;
//     bindMobileDrawerGlobalsOnce.did = true;

//     document.addEventListener('keydown', function (e) {
//       if (e.key !== 'Escape' || !document.body.classList.contains(MOBILE_DRAWER_BODY_CLASS)) return;
//       syncMobileDrawerOpen(false);
//       var ob = document.querySelector('.custom-header__hambergur-btn');
//       if (ob) ob.focus();
//     });

//     window.addEventListener('resize', function () {
//       if (!window.matchMedia('(min-width: 1025px)').matches) return;
//       if (!document.body.classList.contains(MOBILE_DRAWER_BODY_CLASS)) return;
//       syncMobileDrawerOpen(false);
//     });
//   }

//   var MOBILE_HEADER_SEARCH_MQ = window.matchMedia('(max-width: 1024px)');
//   var mobileSearchActiveRoot = null;

//   function mobileSearchDocClick(e) {
//     if (!mobileSearchActiveRoot) return;
//     if (mobileSearchActiveRoot.contains(e.target)) return;
//     closeMobileHeaderSearch(mobileSearchActiveRoot);
//   }

//   function setMobileHeaderSearchDockTop() {
//     var h = findCustomHeader();
//     if (!h) return;
//     var bottom = Math.round(h.getBoundingClientRect().bottom);
//     document.documentElement.style.setProperty('--mobile-header-search-top', bottom + 'px');
//   }

//   function closeMobileHeaderSearch(root) {
//     if (!root) return;
//     root.classList.remove('header-inline-search--mobile-open');
//     document.body.classList.remove('is-mobile-header-search-open');
//     if (mobileSearchActiveRoot === root) {
//       document.removeEventListener('click', mobileSearchDocClick);
//       mobileSearchActiveRoot = null;
//     }
//     var trig = root.querySelector('[data-mobile-header-search-trigger]');
//     if (trig) trig.setAttribute('aria-expanded', 'false');
//     root.dispatchEvent(new CustomEvent('predictive-search:close'));
//     var input = root.querySelector('[data-predictive-search-input]');
//     if (input) input.blur();
//     document.documentElement.style.removeProperty('--mobile-header-search-top');
//     if (trig) {
//       window.requestAnimationFrame(function () {
//         try {
//           trig.focus({ preventScroll: true });
//         } catch (err) {}
//       });
//     }
//   }

//   function openMobileHeaderSearch(root) {
//     root.classList.add('header-inline-search--mobile-open');
//     document.body.classList.add('is-mobile-header-search-open');
//     setMobileHeaderSearchDockTop();
//     var trig = root.querySelector('[data-mobile-header-search-trigger]');
//     if (trig) trig.setAttribute('aria-expanded', 'true');
//     var input = root.querySelector('[data-predictive-search-input]');
//     if (input) {
//       window.requestAnimationFrame(function () {
//         input.focus({ preventScroll: true });
//       });
//     }
//     if (mobileSearchActiveRoot && mobileSearchActiveRoot !== root) {
//       document.removeEventListener('click', mobileSearchDocClick);
//     }
//     mobileSearchActiveRoot = root;
//     window.setTimeout(function () {
//       if (mobileSearchActiveRoot !== root) return;
//       document.addEventListener('click', mobileSearchDocClick);
//     }, 0);
//   }

//   function syncMobileHeaderSearchMq() {
//     if (MOBILE_HEADER_SEARCH_MQ.matches) return;
//     document.querySelectorAll('[data-header-inline-search].header-inline-search--mobile-open').forEach(function (root) {
//       closeMobileHeaderSearch(root);
//     });
//   }

//   function bindMobileHeaderSearchGlobalsOnce() {
//     if (bindMobileHeaderSearchGlobalsOnce.did) return;
//     bindMobileHeaderSearchGlobalsOnce.did = true;

//     document.addEventListener('keydown', function (e) {
//       if (e.key !== 'Escape') return;
//       document.querySelectorAll('[data-header-inline-search].header-inline-search--mobile-open').forEach(function (root) {
//         closeMobileHeaderSearch(root);
//       });
//     });

//     window.addEventListener('scroll', function () {
//       if (!mobileSearchActiveRoot) return;
//       if (!MOBILE_HEADER_SEARCH_MQ.matches) return;
//       setMobileHeaderSearchDockTop();
//     }, { passive: true });

//     window.addEventListener('resize', function () {
//       syncMobileHeaderSearchMq();
//       if (mobileSearchActiveRoot && MOBILE_HEADER_SEARCH_MQ.matches) setMobileHeaderSearchDockTop();
//     });

//     if (typeof MOBILE_HEADER_SEARCH_MQ.addEventListener === 'function') {
//       MOBILE_HEADER_SEARCH_MQ.addEventListener('change', syncMobileHeaderSearchMq);
//     } else if (typeof MOBILE_HEADER_SEARCH_MQ.addListener === 'function') {
//       MOBILE_HEADER_SEARCH_MQ.addListener(syncMobileHeaderSearchMq);
//     }
//   }

//   function initMobileHeaderSearch() {
//     bindMobileHeaderSearchGlobalsOnce();

//     document.querySelectorAll('[data-header-inline-search]').forEach(function (root) {
//       if (root.getAttribute('data-mobile-search-js') === '1') return;
//       root.setAttribute('data-mobile-search-js', '1');

//       var trigger = root.querySelector('[data-mobile-header-search-trigger]');
//       var cancel = root.querySelector('[data-mobile-header-search-cancel]');
//       if (!trigger) return;

//       trigger.addEventListener('click', function (e) {
//         e.preventDefault();
//         if (!MOBILE_HEADER_SEARCH_MQ.matches) return;
//         if (root.classList.contains('header-inline-search--mobile-open')) {
//           closeMobileHeaderSearch(root);
//         } else {
//           openMobileHeaderSearch(root);
//         }
//       });

//       if (cancel) {
//         cancel.addEventListener('click', function (e) {
//           e.preventDefault();
//           closeMobileHeaderSearch(root);
//         });
//       }
//     });
//   }

//   function initMobileDrawer() {
//     var openBtn = document.querySelector('.custom-header__hambergur-btn');
//     var drawerRoot = document.querySelector('[data-mobile-drawer]');
//     if (!openBtn || !drawerRoot) return;
//     if (drawerRoot.getAttribute('data-drawer-js') === '1') return;
//     drawerRoot.setAttribute('data-drawer-js', '1');

//     bindMobileDrawerGlobalsOnce();

//     var closeBtn = drawerRoot.querySelector('[data-mobile-drawer-close]');

//     function openDrawer() {
//       syncMobileDrawerOpen(true);
//       window.requestAnimationFrame(function () {
//         if (closeBtn) closeBtn.focus();
//       });
//     }

//     function closeDrawer() {
//       syncMobileDrawerOpen(false);
//       openBtn.focus();
//     }

//     openBtn.addEventListener('click', function (e) {
//       e.preventDefault();
//       if (document.body.classList.contains(MOBILE_DRAWER_BODY_CLASS)) {
//         closeDrawer();
//       } else {
//         openDrawer();
//       }
//     });

//     if (closeBtn) {
//       closeBtn.addEventListener('click', function (e) {
//         e.preventDefault();
//         closeDrawer();
//       });
//     }
//   }

//   function init() {
//     initHeaderSticky();
//     mountMegaNavGrids();
//     initMegaMenu();
//     initMobileDrawer();
//     initMobileHeaderSearch();
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }

//   window.requestAnimationFrame(function () {
//     refreshStickStart();
//   });
// })();


(function () {
  var BODY_STICKY_CLASS = 'is-custom-header-sticky';
  var headerEl = null;
  var stickStartY = 0;
  var scrollRaf = 0;

  function findCustomHeader() {
    var inner = document.querySelector('.custom-header');
    return inner ? inner.closest('header') : null;
  }

  function readStickStartY() {
    if (!headerEl) return 0;
    var had = document.body.classList.contains(BODY_STICKY_CLASS);
    document.body.classList.remove(BODY_STICKY_CLASS);
    void headerEl.offsetHeight;
    var y = Math.round(headerEl.getBoundingClientRect().top + window.scrollY);
    if (had) document.body.classList.add(BODY_STICKY_CLASS);
    return y;
  }

  function refreshStickStart() {
    headerEl = findCustomHeader();
    if (!headerEl) return;
    stickStartY = readStickStartY();
    syncStickyClass();
  }

  function syncStickyClass() {
    if (!headerEl) return;
    document.body.classList.toggle(BODY_STICKY_CLASS, window.scrollY >= stickStartY);
  }

  function onScroll() {
    if (!headerEl) return;
    if (scrollRaf) return;
    scrollRaf = window.requestAnimationFrame(function () {
      scrollRaf = 0;
      syncStickyClass();
    });
  }

  function initHeaderSticky() {
    refreshStickStart();
    if (!headerEl) return;

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', refreshStickStart);
    window.addEventListener('orientationchange', refreshStickStart);

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function () {
        refreshStickStart();
        mountMegaNavGrids();
        initMegaMenuBackdrop();
        initMobileDrawer();
      });
      document.addEventListener('shopify:section:unload', refreshStickStart);
      document.addEventListener('shopify:section:reorder', refreshStickStart);
    }

    syncStickyClass();
  }

  function setActivePanel(menu, handle) {
    var panels = menu.querySelectorAll('[data-product-panel]');
    var matched = false;
    panels.forEach(function (panel) {
      var isMatch = handle && panel.getAttribute('data-product-panel') === handle;
      panel.classList.toggle('is-active', isMatch);
      if (isMatch) matched = true;
    });
    if (!matched && panels.length) {
      var fallback = menu.getAttribute('data-default-panel');
      panels.forEach(function (panel) {
        panel.classList.toggle('is-active', !!(fallback && panel.getAttribute('data-product-panel') === fallback));
      });
    }
  }

  function stripBoldTags(str) {
    return String(str || '')
      .replace(/<\s*b\s*>/gi, '')
      .replace(/<\s*\/\s*b\s*>/gi, '')
      .trim();
  }

  function mountMegaNavGrids() {
    document.querySelectorAll('[data-mega-nav-uid]').forEach(function (el) {
      var uid = el.getAttribute('data-mega-nav-uid');
      if (!uid) return;
      var scriptEl = document.getElementById('mega-nav-data-' + uid);
      if (!scriptEl || !scriptEl.textContent) return;
      var groups;
      try {
        groups = JSON.parse(scriptEl.textContent.trim());
      } catch (err) {
        return;
      }
      if (!Array.isArray(groups) || !groups.length) return;

      el.innerHTML = '';
      var grid = document.createElement('div');
      grid.className = 'custom-header__mega-nav-grid';
      el.appendChild(grid);

      groups.forEach(function (g) {
        var col = document.createElement('div');
        col.className = 'custom-header__mega-nav-column';

        var headingWrap = document.createElement('p');
        headingWrap.className = 'custom-header__mega-nav-column__heading';
        var headA = document.createElement('a');
        headA.href = g.url && String(g.url).trim() ? g.url : '#';
        headA.className = 'custom-header__mega-nav-column__heading-link';
        headA.textContent = stripBoldTags(g.headline);
        headingWrap.appendChild(headA);
        col.appendChild(headingWrap);

        var ul = document.createElement('ul');
        ul.className = 'custom-header__mega-nav-column__list';
        (g.children || []).forEach(function (ch) {
          var li = document.createElement('li');
          li.className = 'custom-header__mega-nav-column__item';
          var a = document.createElement('a');
          a.href = ch.url && String(ch.url).trim() ? ch.url : '#';
          a.className = 'custom-header__menu-list-link--child custom-header__menu-list-link--child-2';
          a.textContent = stripBoldTags(ch.title);
          li.appendChild(a);
          ul.appendChild(li);
        });
        col.appendChild(ul);
        grid.appendChild(col);
      });
    });
  }

  var MEGA_BACKDROP_MQ = window.matchMedia('(min-width: 1025px)');
  var megaBackdropResizeBound = false;

  function updateMegaMenuBackdrop() {
    var root = document.querySelector('.custom-header');
    var list = root && root.querySelector('.custom-header__menu-list');
    if (!root || !list) {
      if (root) root.classList.remove('is-mega-backdrop-visible');
      return;
    }
    if (!MEGA_BACKDROP_MQ.matches) {
      root.classList.remove('is-mega-backdrop-visible');
      return;
    }
    var show = false;
    for (var i = 0; i < list.children.length; i++) {
      var li = list.children[i];
      if (li.tagName !== 'LI' || !li.querySelector('.custom-header__sub-menu')) continue;
      if (li.matches(':hover') || li.contains(document.activeElement)) {
        show = true;
        break;
      }
    }
    root.classList.toggle('is-mega-backdrop-visible', show);
  }

  function initMegaMenuBackdrop() {
    var root = document.querySelector('.custom-header');
    var list = root && root.querySelector('.custom-header__menu-list');
    if (!root || !list) return;

    function megaLis() {
      return Array.prototype.slice.call(list.children).filter(function (node) {
        return node.tagName === 'LI' && node.querySelector('.custom-header__sub-menu');
      });
    }

    megaLis().forEach(function (li) {
      if (li.getAttribute('data-mega-backdrop-li') === '1') return;
      li.setAttribute('data-mega-backdrop-li', '1');
      li.addEventListener('mouseenter', updateMegaMenuBackdrop);
      li.addEventListener('mouseleave', updateMegaMenuBackdrop);
    });

    if (list.getAttribute('data-mega-backdrop-focus') !== '1') {
      list.setAttribute('data-mega-backdrop-focus', '1');
      list.addEventListener('focusin', updateMegaMenuBackdrop);
      list.addEventListener('focusout', function () {
        window.requestAnimationFrame(updateMegaMenuBackdrop);
      });
    }

    if (!megaBackdropResizeBound) {
      megaBackdropResizeBound = true;
      window.addEventListener('resize', updateMegaMenuBackdrop);
    }
  }

  function initMegaMenu() {
    document.querySelectorAll('[data-mega-menu]').forEach(function (menu) {
      var triggers = menu.querySelectorAll('[data-product-panel-trigger]');

      menu.addEventListener('mouseenter', function () {
        var def = menu.getAttribute('data-default-panel');
        if (def) setActivePanel(menu, def);
      });

      triggers.forEach(function (li) {
        li.addEventListener('mouseenter', function () {
          var handle = li.getAttribute('data-product-panel-trigger');
          if (handle) setActivePanel(menu, handle);
        });
      });

      menu.addEventListener('mouseleave', function () {
        var def = menu.getAttribute('data-default-panel');
        if (def) setActivePanel(menu, def);
      });
    });
  }

  var MOBILE_DRAWER_BODY_CLASS = 'header__drawwer-open';

  function syncMobileDrawerOpen(isOpen) {
    var drawerRoot = document.querySelector('[data-mobile-drawer]');
    var openBtn = document.querySelector('.custom-header__hambergur-btn');
    document.body.classList.toggle(MOBILE_DRAWER_BODY_CLASS, isOpen);
    if (drawerRoot) {
      drawerRoot.classList.toggle('is-open', isOpen);
      drawerRoot.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    }
    if (openBtn) openBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  function bindMobileDrawerGlobalsOnce() {
    if (bindMobileDrawerGlobalsOnce.did) return;
    bindMobileDrawerGlobalsOnce.did = true;

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !document.body.classList.contains(MOBILE_DRAWER_BODY_CLASS)) return;
      syncMobileDrawerOpen(false);
      var ob = document.querySelector('.custom-header__hambergur-btn');
      if (ob) ob.focus();
    });

    window.addEventListener('resize', function () {
      if (!window.matchMedia('(min-width: 1025px)').matches) return;
      if (!document.body.classList.contains(MOBILE_DRAWER_BODY_CLASS)) return;
      syncMobileDrawerOpen(false);
    });
  }

  var MOBILE_HEADER_SEARCH_MQ = window.matchMedia('(max-width: 1024px)');
  var mobileSearchActiveRoot = null;

  function mobileSearchDocClick(e) {
    if (!mobileSearchActiveRoot) return;
    if (mobileSearchActiveRoot.contains(e.target)) return;
    closeMobileHeaderSearch(mobileSearchActiveRoot);
  }

  function setMobileHeaderSearchDockTop() {
    var h = findCustomHeader();
    if (!h) return;
    var bottom = Math.round(h.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--mobile-header-search-top', bottom + 'px');
  }

  function closeMobileHeaderSearch(root) {
    if (!root) return;
    root.classList.remove('header-inline-search--mobile-open');
    document.body.classList.remove('is-mobile-header-search-open');
    if (mobileSearchActiveRoot === root) {
      document.removeEventListener('click', mobileSearchDocClick);
      mobileSearchActiveRoot = null;
    }
    var trig = root.querySelector('[data-mobile-header-search-trigger]');
    if (trig) trig.setAttribute('aria-expanded', 'false');
    root.dispatchEvent(new CustomEvent('predictive-search:close'));
    var input = root.querySelector('[data-predictive-search-input]');
    if (input) input.blur();
    document.documentElement.style.removeProperty('--mobile-header-search-top');
    if (trig) {
      window.requestAnimationFrame(function () {
        try {
          trig.focus({ preventScroll: true });
        } catch (err) {}
      });
    }
  }

  function openMobileHeaderSearch(root) {
    root.classList.add('header-inline-search--mobile-open');
    document.body.classList.add('is-mobile-header-search-open');
    setMobileHeaderSearchDockTop();
    var trig = root.querySelector('[data-mobile-header-search-trigger]');
    if (trig) trig.setAttribute('aria-expanded', 'true');
    var input = root.querySelector('[data-predictive-search-input]');
    if (input) {
      window.requestAnimationFrame(function () {
        input.focus({ preventScroll: true });
      });
    }
    if (mobileSearchActiveRoot && mobileSearchActiveRoot !== root) {
      document.removeEventListener('click', mobileSearchDocClick);
    }
    mobileSearchActiveRoot = root;
    window.setTimeout(function () {
      if (mobileSearchActiveRoot !== root) return;
      document.addEventListener('click', mobileSearchDocClick);
    }, 0);
  }

  function syncMobileHeaderSearchMq() {
    if (MOBILE_HEADER_SEARCH_MQ.matches) return;
    document.querySelectorAll('[data-header-inline-search].header-inline-search--mobile-open').forEach(function (root) {
      closeMobileHeaderSearch(root);
    });
  }

  function bindMobileHeaderSearchGlobalsOnce() {
    if (bindMobileHeaderSearchGlobalsOnce.did) return;
    bindMobileHeaderSearchGlobalsOnce.did = true;

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-header-inline-search].header-inline-search--mobile-open').forEach(function (root) {
        closeMobileHeaderSearch(root);
      });
    });

    window.addEventListener('scroll', function () {
      if (!mobileSearchActiveRoot) return;
      if (!MOBILE_HEADER_SEARCH_MQ.matches) return;
      setMobileHeaderSearchDockTop();
    }, { passive: true });

    window.addEventListener('resize', function () {
      syncMobileHeaderSearchMq();
      if (mobileSearchActiveRoot && MOBILE_HEADER_SEARCH_MQ.matches) setMobileHeaderSearchDockTop();
    });

    if (typeof MOBILE_HEADER_SEARCH_MQ.addEventListener === 'function') {
      MOBILE_HEADER_SEARCH_MQ.addEventListener('change', syncMobileHeaderSearchMq);
    } else if (typeof MOBILE_HEADER_SEARCH_MQ.addListener === 'function') {
      MOBILE_HEADER_SEARCH_MQ.addListener(syncMobileHeaderSearchMq);
    }
  }

  function initMobileHeaderSearch() {
    bindMobileHeaderSearchGlobalsOnce();

    document.querySelectorAll('[data-header-inline-search]').forEach(function (root) {
      if (root.getAttribute('data-mobile-search-js') === '1') return;
      root.setAttribute('data-mobile-search-js', '1');

      var trigger = root.querySelector('[data-mobile-header-search-trigger]');
      var cancel = root.querySelector('[data-mobile-header-search-cancel]');
      if (!trigger) return;

      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (!MOBILE_HEADER_SEARCH_MQ.matches) return;
        if (root.classList.contains('header-inline-search--mobile-open')) {
          closeMobileHeaderSearch(root);
        } else {
          openMobileHeaderSearch(root);
        }
      });

      if (cancel) {
        cancel.addEventListener('click', function (e) {
          e.preventDefault();
          closeMobileHeaderSearch(root);
        });
      }
    });
  }

  function initMobileDrawer() {
    var openBtn = document.querySelector('.custom-header__hambergur-btn');
    var drawerRoot = document.querySelector('[data-mobile-drawer]');
    if (!openBtn || !drawerRoot) return;
    if (drawerRoot.getAttribute('data-drawer-js') === '1') return;
    drawerRoot.setAttribute('data-drawer-js', '1');

    bindMobileDrawerGlobalsOnce();

    var closeBtn = drawerRoot.querySelector('[data-mobile-drawer-close]');

    function openDrawer() {
      syncMobileDrawerOpen(true);
      window.requestAnimationFrame(function () {
        if (closeBtn) closeBtn.focus();
      });
    }

    function closeDrawer() {
      syncMobileDrawerOpen(false);
      openBtn.focus();
    }

    openBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (document.body.classList.contains(MOBILE_DRAWER_BODY_CLASS)) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closeDrawer();
      });
    }
  }

  function init() {
    initHeaderSticky();
    mountMegaNavGrids();
    initMegaMenuBackdrop();
    initMegaMenu();
    initMobileDrawer();
    initMobileHeaderSearch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.requestAnimationFrame(function () {
    refreshStickStart();
  });
})();
